<!-- Layout 2: Text Left, Image Right -->
<div class="section-container" *ngIf="data?.title || data?.description || data?.buttonText">
  <div class="section-content">
    <h2 class="section-title"
        *ngIf="data?.title"
        [style.color]="headingColor"
        [style.font-family]="headingFont"
        [ngStyle]="titleStyles || data?.titleStyle">{{ data?.title }}</h2>
    <p class="section-description"
       *ngIf="data?.description"
       [style.color]="paragraphColor"
       [style.font-family]="bodyFont">
      {{ data?.description }}
    </p>
    <button class="section-btn"
            *ngIf="data?.buttonText"
            [style.background-color]="primaryColor"
            [style.color]="headingColor"
            (click)="onButtonClick(data?.buttonLink, $event)">{{ data?.buttonText }}</button>
  </div>
  <div class="section-image" *ngIf="getImageSrc()">
    <img [src]="getImageSrc()" 
         [alt]="getImageAlt()"
         [style.object-fit]="getImageObjectFit()"
         class="detail-image">
  </div>
</div>

